import React from "react";
import "./Styles.css";

const About = () => (
  <div className="content">
    <h1>About This Website</h1>
    <p>
      This website is a tutorial for creating and deploying a React application
      to the Arweave permaweb using the ArDrive web app. While the concepts and
      techniques can apply to any React application, we've tailored the content
      to specifically guide you through building a simple React app with Create
      React App, setting up hash routing and relative file paths, and deploying
      it to Arweave.
    </p>
    <h2>Why Hash Routing and Relative File Paths?</h2>
    <p>
      When you deploy an application to Arweave, it gets stored in a
      decentralized network of servers. This means there's no central server
      where we can configure how requests are handled, which makes traditional
      history routing and absolute file paths unsuitable.
    </p>
    <p>
      Instead, we use hash routing and relative file paths. Hash routing handles
      all routing on the client side, using the hash part of the URL to control
      the page state. Relative file paths refer to other files within the same
      project, making them perfect for a decentralized storage system like
      Arweave, where there's no central root directory.
    </p>
    <h2>Why Deploy to ArDrive?</h2>
    <p>
      ArDrive is a community-driven project that provides a simple,
      user-friendly interface for interacting with the Arweave permaweb. By
      deploying your static websites or apps to the permaweb using ArDrive,
      you're ensuring that they're permanently hosted with 100% uptime,
      regardless of any changes to the original source files.
    </p>
    <h2>What is Arweave?</h2>
    <p>
      Arweave is a new type of storage that backs data with sustainable and
      perpetual endowments, allowing users and developers to truly store data
      forever. Arweave accomplishes this by using a novel blockchain-like data
      structure called the blockweave, which is designed from the ground up to
      provide scalable on-chain storage in a cost-effective manner.
    </p>
    <p>
      The Arweave permaweb is a global, permanent hard drive built on top of the
      Arweave network. Once you upload something to the permaweb, it's there
      forever. And because the permaweb is decentralized, there's no central
      authority that can remove or censor your content.
    </p>
  </div>
);

export default About;
